import PropTypes from 'prop-types'

import DDIcon from '../../icons/DDIcon'
import styles from './Callout.module.css'

const ICON_BY_VARIANT = {
  info: null, // info variant shows a bank logo instead of an icon, see `logoUrl`
  warning: 'callout-warning-note',
  error: 'helper-error',
}

/**
 * Spec §5.9 — info (send-from-bank), warning, and error banners share one layout
 * (icon/logo + text); the account-name confirmation banner has its own two-part layout
 * and is handled as a distinct `variant='account-name'` render path.
 */
const Callout = ({ variant, children, logoUrl, accountNameValue }) => {
  if (variant === 'account-name') {
    return (
      <div className={styles.accountName} role='status' aria-live='polite'>
        <span className={styles.accountNameLabel}>Account name</span>
        <span className={styles.accountNameValue}>{accountNameValue}</span>
      </div>
    )
  }

  const liveProps =
    variant === 'error'
      ? { role: 'alert' }
      : { role: 'status', 'aria-live': 'polite' }

  return (
    <div className={[styles.callout, styles[variant]].join(' ')} {...liveProps}>
      {variant === 'info' ? (
        <span className={styles.logo}>
          {logoUrl ? <img className={styles.logoImg} src={logoUrl} alt='' /> : <DDIcon name='table-bank' />}
        </span>
      ) : (
        <DDIcon name={ICON_BY_VARIANT[variant]} />
      )}
      <span>{children}</span>
    </div>
  )
}

Callout.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'error', 'account-name']).isRequired,
  children: PropTypes.node,
  logoUrl: PropTypes.string,
  accountNameValue: PropTypes.string,
}

export default Callout

// Spec §5.9 — wrap the emphasised span inside an info callout's children with this class,
// e.g. <Callout variant="info">Send from <span className={emphasisClassName}>GT Bank •••• 5067</span> only.</Callout>
export const calloutEmphasisClassName = styles.emphasis
